import { FieldViewProps } from './field.model';
import { FieldView } from './field.view';

export const FieldController = (props: FieldViewProps) => {
  return <FieldView {...props} />;
};
